import ConcluirCadastro from '../../pages/usuario/concluirCadastro';
import Sucesso from '../../pages/sucesso';
import NotFound from '../../pages/semPermissao';

const indexRoutes = [
  { path: '/concluir-cadastro', component: ConcluirCadastro },
  { path: '/sucesso', component: Sucesso },
  { component: NotFound }
];

export default indexRoutes;
